import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { ProfileState } from './types'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'


export const state: ProfileState = {
  user: undefined,
  error: false,
}

const namespaced: boolean = true

export const profile: Module<ProfileState, RootState> = {
  namespaced,
  state,
  getters,
  mutations,
  actions,
}
